<template lang="pug">
.grid.preview(:style="style")
    .area(
        v-for="(area, i) in areas"
        ref="areas"
        :class="{ active: activeArea && activeArea.id == area.id }"
        :style="getAreaStyle(area)"
    )
        h4.title {{ area.name || $t('Area') }}
        //- pre {{ area.id }}
        template(v-if="type === 'create' && (!activeArea || buttons[i])")
            //- :plain="!!activeArea"
            el-button.set-position.first(
                v-if="!activeArea || buttons[i].start"
                type="primary"
                icon="el-icon-fa-plus fas"
                size="mini"
                circle
                @click.stop="updatePosition(i, { column: 'start', row: 'start' })"
            )
            //- :plain="!!activeArea"
            el-button.set-position(
                v-if="!activeArea || buttons[i].end"
                type="primary"
                icon="el-icon-fa-plus fas"
                size="mini"
                circle
                @click.stop="updatePosition(i, { column: 'end', row: 'start' })"
            )
    //- pre {{ activeArea }}
</template>

<i18n>
{
    "de": {
        "Area": "Rasterelement"
    }
}
</i18n>

<script>
import { getActiveGridConfig } from '@/helpers'
import { useSetupStore } from '@/stores'

const fixCalculatedPositions = calculated => {
    const types = ['row', 'column']
    types.forEach(type => {
        if (calculated[type].start === 'auto' || parseInt(calculated[type].start) === NaN) {
            calculated[type].start = 1
        } else if (parseInt(calculated[type].start) !== NaN) {
            calculated[type].start = parseInt(calculated[type].start)
        }
        if (calculated[type].end === 'auto' || parseInt(calculated[type].end) === NaN
            || calculated[type].end <= calculated[type].start) {
            calculated[type].end = parseInt(calculated[type].start) + 1;
        } else if (parseInt(calculated[type].end) !== NaN) {
            calculated[type].end = parseInt(calculated[type].end)
        }
    })
}

export default {
    name: 'GridPreview',
    props: {
        type: {
            type: String,
            required: true
        },
        rows: {
            type: Array,
            required: true
        },
        columns: {
            type: Array,
            required: true
        },
        activeBreakpoint: {
            type: Object,
            required: true
        },
        areas: {
            type: Array,
            required: false
        },
        activeArea: {
            type: Object,
            required: false
        },
    },
    data: () => ({
        buttons: [],
    }),
    watch: {
        activeArea: {
            handler() {
                this.$nextTick(this.updateButtons)
            },
            deep: true,
        },
    },
    computed: {
        breakpoints() {
            return _.get(this.activeCms, 'config.template.breakpoints') || []
        },
        activeGridConfig() {
            let config = {
                rows: [],
                columns: [],
            }

            // get current breakpoint (manually selectable)
            // get corresponding style config
            if (this.breakpoints.length && this.activeBreakpoint) {
                const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map((el, i) => el.key)
                config.rows = getActiveGridConfig(indexes, this.rows, this.activeBreakpoint.key)
                config.columns = getActiveGridConfig(indexes, this.columns, this.activeBreakpoint.key)
            }

            return config
        },
        style() {
            return {
                'grid-template-rows': this.activeGridConfig.rows.join(' '),
                // 'grid-template-columns': this.activeGridConfig.columns.join(' '),
                'grid-template-columns': this.activeGridConfig.columns.map(col => {
                    if (col.trim().indexOf(' ') >= 0) return col
                    else return `minmax(min-content, ${col})`
                }).join(' '),
                // // 'grid-template-rows': this.activeGridConfig.rows.map(value => `minmax(min-content, ${value})`).join(' '),
                // // 'grid-template-columns': this.activeGridConfig.columns.map(value => `minmax(min-content, ${value})`).join(' '),
                // 'grid-template-rows': this.activeGridConfig.rows.map(value => `minmax(3rem, ${value})`).join(' '),
                // 'grid-template-columns': this.activeGridConfig.columns.map(value => `minmax(3rem, ${value})`).join(' '),
            }
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
    methods: {
        getAreaStyle(area) {
            let row, column

            if (this.breakpoints.length && this.activeBreakpoint) {
                let config = {
                    row: [],
                    column: [],
                }

                const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map((el, i) => el.key)
                config.row = getActiveGridConfig(indexes, area.row, this.activeBreakpoint.key)
                config.column = getActiveGridConfig(indexes, area.column, this.activeBreakpoint.key)

                if (config.row && _.isArray(config.row)) row = config.row.join(' ')
                else row = config.row

                if (config.column && _.isArray(config.column)) column = config.column.join(' ')
                else column = config.column
            }

            return {
                'grid-row': row,
                'grid-column': column,
            }
        },
        updatePosition(i, position) {
            if (!this.$refs.areas || !this.$refs.areas[i]) return

            const areaStyles = window.getComputedStyle(this.$refs.areas[i])
            const calculated = {
                column: {
                    start: areaStyles.getPropertyValue('grid-column-start'),
                    end: areaStyles.getPropertyValue('grid-column-end'),
                },
                row: {
                    start: areaStyles.getPropertyValue('grid-row-start'),
                    end: areaStyles.getPropertyValue('grid-row-end'),
                },
            }

            fixCalculatedPositions(calculated)

            const payload = {
                column: calculated.column[position.column],
                row: calculated.row[position.row],
            }

            // check if the active area position is in the way
            const activeAreaPostion = this.getActiveAreaPostion()

            if (activeAreaPostion) {
                if (activeAreaPostion.column.end <= payload.column
                    && payload.row >= activeAreaPostion.row.start && payload.row <= activeAreaPostion.row.end - 1) {
                    const span = activeAreaPostion.column.end - activeAreaPostion.column.start
                    payload.column -= span
                }

                // if (activeAreaPostion.row.end <= payload.row) {
                //     const span = activeAreaPostion.row.end - activeAreaPostion.row.start
                //     payload.row -= span
                // }
            }

            this.$emit('update:position', payload)
        },

        getActiveAreaPostion() {
            if (!this.activeArea) return

            let calculated
            const i = this.areas.findIndex(area => area.id === this.activeArea.id)
            if (i >= 0 && this.$refs.areas && this.$refs.areas[i]) {
                const activeAreaStyles = window.getComputedStyle(this.$refs.areas[i])
                calculated = {
                    column: {
                        start: activeAreaStyles.getPropertyValue('grid-column-start'),
                        end: activeAreaStyles.getPropertyValue('grid-column-end'),
                    },
                    row: {
                        start: activeAreaStyles.getPropertyValue('grid-row-start'),
                        end: activeAreaStyles.getPropertyValue('grid-row-end'),
                    },
                }

                fixCalculatedPositions(calculated)
            }
            return calculated
        },

        updateButtons() {
            if (!this.activeArea) return

            const activeAreaPostion = this.getActiveAreaPostion()

            this.buttons = []
            this.areas.forEach((area, i) => {
                if (area.id === this.activeArea.id) {
                    this.buttons.push({ start: false, end: false })
                } else {
                    const areaStyles = window.getComputedStyle(this.$refs.areas[i])
                    const calculated = {
                        column: {
                            start: areaStyles.getPropertyValue('grid-column-start'),
                            end: areaStyles.getPropertyValue('grid-column-end'),
                        },
                        row: {
                            start: areaStyles.getPropertyValue('grid-row-start'),
                            end: areaStyles.getPropertyValue('grid-row-end'),
                        },
                    }

                    fixCalculatedPositions(calculated)

                    let start = true
                    let end = true
                    if (calculated.row.start < activeAreaPostion.row.end && calculated.row.end > activeAreaPostion.row.start) {
                        start = calculated.column.start !== activeAreaPostion.column.end
                        end = calculated.column.end !== activeAreaPostion.column.start
                    }

                    // payload.row >= activeAreaPostion.row.start && payload.row <= activeAreaPostion.row.end - 1) {

                    this.buttons.push({ start, end })
                }
            })
        },
    },
    mounted() {
        this.$nextTick(this.updateButtons)
    },
}
</script>

<style lang="sass" scoped>
$gap: 0.2rem

.grid
    background-color: #fff
    padding: $gap 20px
    display: grid
    gap: $gap
    position: relative
    .area
        // background-color: $color-body
        background-color: rgba(0, 0, 0, 0.1)
        position: relative
        border-radius: 0.5rem
        padding: 1rem
        min-height: 6rem
        display: flex
        align-items: center
        justify-content: center
        color: rgba(0, 0, 0, 0.5)
        // text-transform: uppercase
        &.active
            background-color: rgba($--color-primary, 1)
            color: #fff
    h4.title
        margin: 0
        // font-size: 0.75rem
        font-weight: 400
        line-height: 1.5
        color: inherit
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
.set-position
    position: absolute
    right: calc(28px / 2 * -1 - ($gap / 2))
    z-index: 2
    outline: $gap solid #fff
    &.first
        right: auto
        left: calc(28px / 2 * -1 - ($gap / 2))
</style>
